// GENERATED FILE - DO NOT EDIT.
// Produced by web/scripts/generate-protocol.mjs from the Java sources in
// engine/src/main/java/utilities/. Change the Java constants and regenerate.
export const Protocol = Object.freeze({
  JSONSeedID: "seed",
  JSONCardTypeID: "card_type",
  JSONHandsID: "hands",
  JSONTagID: "tag",
  JSONDeckSizeID: "deck_size",
  JSONDeckArrayID: "deck_array",
  JSONAdditionalInformationID: "additional_information",
  JSONPlayedCardID: "played_card",
  JSONAddedCardID: "added_card",
  JSONPlayersResultsID: "players_results",
  JSONPlayersPartialResultsTag: "players_partial_results",
  JSONPlayersFinalResultsTag: "players_final_results",
  JSONStartMatchTag: "start_match",
  JSONMessageCounterID: "message_counter",
  JSONSyncDataTag: "sync_data",
  JSONOriginalDeckArrayID: "original_deck_array",
  JSONCurrentBetID: "current_bet",
  JSONCurrentPlayerID: "current_player",
  JSONStartingPlayerMatchID: "starting_player_match",
  JSONStartingPlayerRoundID: "starting_player_round",
  JSONDeletedPlayersPositionsID: "deleted_players_positions",
  JSONStackArrayID: "stack_array",
  JSONStackPlayersArrayID: "stack_players_array",
  JSONStackResultsArrayID: "stack_results_array",
  JSONBetsNumberTag: "bets_number",
  JSONBetsNumberID: "bets_number",
  JSONBriscolaID: "briscola",
  JSONBetTag: "bet",
  JSONForbiddenBetID: "forbidden_bet",
  JSONValidCardsTag: "play_valid_cards",
  JSONValidCardsID: "valid_cards",
  JSONWinnerTag: "winner",
  JSONWinnerID: "winner",
  JSONBetResponseTag: "bet_response",
  JSONPlayerPositionID: "player_position",
  JSONResponseID: "response",
  JSONPlayedValidCardTag: "played_valid_card",
  JSONCardChosenTag: "card_chosen",
  JSONRemovedPlayerTag: "removed_player",
  JSONRemovedPlayerID: "removed_player",
  JSONNextPlayerID: "next_player",
  JSONLoserTag: "loser",
  JSONLoserID: "loser",
  JSONGamePasswordRequiredTag: "password_required",
  JSONGamePasswordRequiredID: "password_required",
  JSONHostPositionID: "host_position",
  JSONPlayersArrayID: "players_array",
  JSONGameNameID: "game_name",
  JSONAllowAIID: "allow_ai",
  JSONAIDifficultyID: "ai_difficulty",
  JSONGameTypeID: "game_type",
  JSONDeckTypeID: "deck_type",
  JSONDeckFormatID: "deck_format",
  JSONPlayersNumberID: "players_number",
  JSONGameLobbyDataTag: "game_lobby_data",
  JSONGamePasswordCorrectID: "password_correct",
  JSONCheckGamePasswordTag: "check_password",
  JSONGamePasswordID: "password",
  JSONPlayerNameTag: "player_name",
  JSONPlayerNameID: "player_name",
  JSONPlayerAddressID: "player_address",
  JSONPlayerAddressPositionID: "player_address_position",
  JSONPlayerReadyTag: "player_ready",
  JSONResetReadinessTag: "reset_readiness",
  JSONDeletePlayerTag: "delete_player",
  JSONDeletePlayerAckTag: "delete_player_ack",
  JSONChangeHostTag: "change_host",
  JSONHostAddressTag: "host_address",
  JSONHostAddressID: "host_address",
  JSONPlayerAddressRequestTag: "player_address_request",
  JSONCloseConnectionRequestTag: "close_connection_request",
  JSONSendNewGameDataTag: "send_new_game_data",
  JSONStartGameTag: "start_game",
  JSONNotifyObjectTag: "notify_object",
  JSONObjectID: "json_object",
  JSONNotifyObjectWithResponseTag: "notify_object_with_response",
  JSONGeneralResponseTag: "general_response",
  JSONExitGameTag: "exit_game",
  JSONCheckConnectionTag: "check_connection",
  JSONCheckConnectionAckTag: "check_connection_ack",
  JSONGameLobbyDataRequestTag: "game_lobby_data_request",
  JSONPlayersReadinessArrayID: "players_readiness_array",
  JSONSenderID: "sender",
  JSONBriscolaSetupTag: "briscola_setup",
  JSONMatchesNumberID: "matches_number",
  JSONHandSizeID: "hand_size",
  JSONTeamsArrayID: "teams_array",
  JSONCurrentMatchID: "current_match",
  JSONBriscolaSeedID: "briscola_seed",
  JSONDrawnCardsTag: "drawn_cards",
  JSONDrawnCardsID: "drawn_cards",
  JSONDeckLeftID: "deck_left",
  JSONTrickPointsID: "trick_points",
  JSONMatchPointsArrayID: "match_points_array",
  JSONAuctionModeID: "auction_mode",
  JSONCallableRanksID: "callable_ranks",
  JSONCalledCardsNumberID: "called_cards_number",
  JSONBidTag: "bid",
  JSONBidOptionsID: "bid_options",
  JSONBidResponseTag: "bid_response",
  JSONBidLevelID: "bid_level",
  JSONCallRankTag: "call_rank",
  JSONCallRankOptionsID: "call_rank_options",
  JSONCalledRankID: "called_rank",
  JSONCallSeedTag: "call_seed",
  JSONCallSeedOptionsID: "call_seed_options",
  JSONCallSeedIndexID: "call_seed_index",
  JSONCallTag: "call",
  JSONCalledCardsID: "called_cards",
  JSONCallerPositionID: "caller_position",
  JSONRequiredPointsID: "required_points",
  JSONPartnerRevealedTag: "partner_revealed",
  JSONPartnerPositionID: "partner_position",
  JSONPartnersArrayID: "partners_array",
  JSONRedealTag: "redeal",
  JSONDeclarationsTag: "declarations",
  JSONDeclarationsID: "declarations",
  JSONDeclarationKindID: "declaration_kind",
  JSONDeclarationValueID: "declaration_value",
  JSONDeclarationThirdsID: "declaration_thirds",
  JSONPassCardsTag: "hearts_pass_card",
  JSONPassDirectionID: "pass_direction",
  JSONPassCardsLeftID: "pass_cards_left",
  JSONPassDoneTag: "hearts_pass_done",
  JSONPassesID: "passes",
  JSONPassFromID: "pass_from",
  JSONPassToID: "pass_to",
  JSONPassedCardsID: "passed_cards",
  JSONHeartsBrokenTag: "hearts_broken",
  JSONMoonShooterID: "moon_shooter",
  JSONScopaSetupTag: "scopa_setup",
  JSONScopaMovesTag: "scopa_moves",
  JSONScopaMovesID: "scopa_moves",
  JSONCapturedCardsID: "captured_cards",
  JSONScopaMovePlayedTag: "scopa_move_played",
  JSONScopaID: "scopa",
  JSONTableCardsID: "table_cards",
  JSONTableSweptTag: "table_swept",
  JSONScopaCardsArrayID: "scopa_cards_array",
  JSONScopaCoinsArrayID: "scopa_coins_array",
  JSONScopaSettebelloArrayID: "scopa_settebello_array",
  JSONScopaPrimieraArrayID: "scopa_primiera_array",
  JSONScopaSweepsArrayID: "scopa_sweeps_array",
  JSONScopaMatchPointsArrayID: "scopa_match_points_array",
  JSONNextPlayerHandSizeID: "next_player_hand_size",
  JSONCardDrawnTag: "card_drawn",
  JSONDrawnFromPositionID: "drawn_from_position",
  JSONDrawerHandSizeID: "drawer_hand_size",
  JSONDrawnFromHandSizeID: "drawn_from_hand_size",
  JSONPairMadeID: "pair_made",
  DECLARATION_SET: 0,
  DECLARATION_NAPOLETANA: 1,
  PASS_LEFT: 0,
  PASS_RIGHT: 1,
  PASS_ACROSS: 2,
  PASS_HOLD: 3,
});

export const ServerProtocol = Object.freeze({
  TagCreateRoom: "create_room",
  TagListRooms: "list_rooms",
  TagListGames: "list_games",
  TagJoinRoom: "join_room",
  TagLeaveRoom: "leave_room",
  TagStartRoomGame: "start_room_game",
  TagReconnect: "reconnect",
  TagChat: "chat",
  TagStats: "stats",
  TagRegister: "register",
  TagLogin: "login",
  TagResumeSession: "resume_session",
  TagLogout: "logout",
  TagChangePassword: "change_password",
  TagSetEmail: "set_email",
  TagVerifyEmail: "verify_email",
  TagRequestPasswordReset: "request_password_reset",
  TagResetPassword: "reset_password",
  TagClaimHistory: "claim_history",
  TagDeleteAccount: "delete_account",
  TagRoomCreated: "room_created",
  TagRoomsList: "rooms_list",
  TagGamesCatalog: "games_catalog",
  TagRoomJoined: "room_joined",
  TagLobbyState: "lobby_state",
  TagRoomClosed: "room_closed",
  TagGameStarting: "game_starting",
  TagPlayerDisconnected: "player_disconnected",
  TagPlayerReconnected: "player_reconnected",
  TagSyncBegin: "sync_begin",
  TagSyncEnd: "sync_end",
  TagChatMessage: "chat_message",
  TagChatHistory: "chat_history",
  TagStatsResult: "stats_result",
  TagAuthOk: "auth_ok",
  TagAuthDone: "auth_done",
  TagError: "error",
  RoomIdID: "room_id",
  RoomsID: "rooms",
  PlayerTokenID: "player_token",
  YourPositionID: "your_position",
  StateID: "state",
  MessageID: "message",
  InResponseToID: "in_response_to",
  PlayersCountID: "players_count",
  ChatTextID: "text",
  ChatEmoteID: "emote",
  ChatSenderNameID: "sender_name",
  ChatSenderPositionID: "sender_position",
  ChatSequenceID: "chat_seq",
  ChatMessagesID: "messages",
  GamesID: "games",
  DifficultiesID: "difficulties",
  EmotesID: "emotes",
  DisplayNameID: "display_name",
  PlayerCountsID: "player_counts",
  EmojiID: "emoji",
  DecksID: "decks",
  DeckFamilyID: "deck_family",
  SeedsID: "seeds",
  CardTypesID: "card_types",
  NameID: "name",
  BidLabelsID: "bid_labels",
  CallRanksID: "call_ranks",
  CallableRanksID: "callable_ranks",
  AuctionModeID: "auction_mode",
  LabelsID: "labels",
  PassLabelID: "pass_label",
  RanksID: "ranks",
  AccountTokenID: "account_token",
  SessionTokenID: "session_token",
  UserNameID: "user_name",
  PasswordID: "password",
  NewPasswordID: "new_password",
  EmailID: "email",
  EmailVerifiedID: "email_verified",
  ResetTokenID: "reset_token",
  VerifyTokenID: "verify_token",
  ClaimableGamesID: "claimable_games",
  RegisteredID: "registered",
  EmailEnabledID: "email_enabled",
  ByGameID: "by_game",
  HeadToHeadID: "head_to_head",
  RecentGamesID: "recent_games",
  PlayedID: "played",
  WonID: "won",
  AheadID: "ahead",
  AverageScoreID: "average_score",
  BestScoreID: "best_score",
  BetsMadeID: "bets_made",
  BetsHitID: "bets_hit",
  TricksWonID: "tricks_won",
  FinishedAtID: "finished_at",
  RankID: "rank",
  ScoreID: "score",
  IsBotID: "is_bot",
  PlayersID: "players",
});
